'use client'

import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

export function HeroBackground() {
	const { resolvedTheme } = useTheme()
	const [loaded, setLoaded] = useState<{
		Player: React.ComponentType<any>
		Comp: React.ComponentType<{ dark?: boolean }>
	} | null>(null)

	useEffect(() => {
		Promise.all([import('@remotion/player'), import('./remotion/EuropeDataFlow')]).then(([playerMod, compMod]) => {
			setLoaded({
				Player: playerMod.Player,
				Comp: compMod.EuropeDataFlow,
			})
		})
	}, [])

	if (!loaded) {
		return <div className="w-full h-full" aria-hidden="true" />
	}

	const { Player, Comp } = loaded

	return (
		<div className="relative w-full h-full overflow-hidden" aria-hidden="true">
			<Player
				component={Comp}
				compositionWidth={1620}
				compositionHeight={1080}
				fps={30}
				durationInFrames={300}
				autoPlay
				loop
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
				}}
				inputProps={{ dark: resolvedTheme === 'dark' }}
			/>
		</div>
	)
}
